import { handleActions } from 'redux-actions';
import immutable from 'immutability-helper';
import { ActionTypes } from '../constants';

const initialState = {
    loading: false,
    error: null,
    notifications: [],
    modalVisible: {
        qr: false,
        confirm: false,
        settings: false,
    },
    theme: 'light',
    sidebarCollapsed: false,
};

export const uiState = { ...initialState };

export default {
    wa_ui: handleActions(
        {
            [ActionTypes.UI_SET_LOADING]: (state, { payload }) => immutable(state, {
                loading: { $set: payload },
            }),

            [ActionTypes.UI_SET_ERROR]: (state, { payload }) => immutable(state, {
                error: { $set: payload },
            }),

            [ActionTypes.UI_CLEAR_ERROR]: state => immutable(state, {
                error: { $set: null },
            }),

            [ActionTypes.UI_SHOW_MODAL]: (state, { payload }) => {
                const { modal, visible } = payload;
                return immutable(state, {
                    modalVisible: {
                        [modal]: { $set: visible },
                    },
                });
            },

            [ActionTypes.UI_TOGGLE_THEME]: state => immutable(state, {
                theme: { $set: state.theme === 'light' ? 'dark' : 'light' },
            }),

            [ActionTypes.UI_TOGGLE_SIDEBAR]: state => immutable(state, {
                sidebarCollapsed: { $set: !state.sidebarCollapsed },
            }),

            [ActionTypes.UI_ADD_NOTIFICATION]: (state, { payload }) => immutable(state, {
                notifications: {
                    $push: [{
                        id: Date.now(),
                        ...payload,
                        timestamp: new Date().toISOString(),
                    }],
                },
            }),

            [ActionTypes.UI_REMOVE_NOTIFICATION]: (state, { payload }) => {
                const index = state.notifications.findIndex(n => n.id === payload);
                if (index === -1) return state;
                return immutable(state, {
                    notifications: { $splice: [[index, 1]] },
                });
            },

            [ActionTypes.UI_CLEAR_NOTIFICATIONS]: state => immutable(state, {
                notifications: { $set: [] },
            }),
        },
        initialState
    ),
};